import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EventCreationForm } from '@datapad/common-controls';
import { useAppContext } from '@datapad/data-model';
import { Add } from '@mui/icons-material';
import { AppBar, Box, Dialog, FormControl, IconButton, InputLabel, MenuItem, Select, Toolbar, Tooltip, } from '@mui/material';
import React from 'react';
export function TimelineToolbar(props) {
    const { sortAscending, onSortChange } = props;
    const appContext = useAppContext();
    const canEdit = appContext.getEffectivePermissionLevel() === 'game-master';
    const [isCreating, setIsCreating] = React.useState(false);
    const sortValue = sortAscending ? 'ascending' : 'descending';
    const handleSortChange = React.useCallback((event) => {
        onSortChange(event.target.value === 'ascending');
    }, [onSortChange]);
    const handleCreateEvent = React.useCallback((event) => {
        if (canEdit) {
            appContext.addEvent(event);
        }
        setIsCreating(false);
    }, [appContext, canEdit]);
    const handleCancelCreate = React.useCallback(() => {
        setIsCreating(false);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(AppBar, { position: "static", color: "default", elevation: 1, children: _jsxs(Toolbar, { sx: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }, children: [_jsxs(FormControl, { size: "small", sx: { minWidth: 200 }, children: [_jsx(InputLabel, { id: "sort-select-label", children: "Events ordering" }), _jsxs(Select, { labelId: "sort-select-label", id: "sort-select", value: sortValue, label: "Events ordering", onChange: handleSortChange, children: [_jsx(MenuItem, { value: "ascending", children: "Oldest first" }), _jsx(MenuItem, { value: "descending", children: "Newest first" })] })] }), canEdit && (_jsx(Box, { children: _jsx(Tooltip, { title: "Add event", children: _jsx(IconButton, { "aria-label": "add event", onClick: () => setIsCreating(true), color: "primary", children: _jsx(Add, {}) }) }) }))] }) }), _jsx(Dialog, { open: isCreating, onClose: handleCancelCreate, maxWidth: "sm", fullWidth: true, "aria-labelledby": "create-event-dialog-title", children: _jsx(EventCreationForm, { onSubmit: handleCreateEvent, onCancel: handleCancelCreate }) })] }));
}
//# sourceMappingURL=TimelineToolbar.js.map